module.exports = __webpack_public_path__ + "static/media/game_win.787357e1.mp3";